// this file is automatically generated by write-revision.ts script
export const release = 'unreleased';
